<form [formGroup]="inputForm" class="border-box">
  <input formControlName="code" type="text" #inputCode
         (keyup)="handleEvent($event)"
         [ngClass]="{'incorrect': invalidTrialCode? invalidTrialCode: false}">
</form>
